export const FilterConfigProp = Object.freeze({
    ColumnFieldOptions: 'columnFieldOptions',
    Columns: 'columns',
    LastFilterId: 'lastFilterId',
});
